export default __webpack_public_path__ + "static/media/promos.b75049e0.webp";